export default __webpack_public_path__ + "static/media/slow-song-basket.25819487.svg";